export default {
  profile: '个人中心',
  settings: '系统设置',
  createContentTip: '创建新内容时，该内容归属于 {label}，请使用{label}录入',
  createContentExample: '例如：新建产品时，产品名称、描述等字段请使用',
  langLevel: '基础: {label}',
};
